import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import styles from './Documentation.module.less';

export default function DocumentationPage() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();

	return (
		<>
			<iframe
				className={styles.documentsContainer}
				title="iframeDocs"
				src="https://docs.virtuix.com/"
			></iframe>
		</>
	);
}
